var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { LineGrid, LineGridDefaultProps } from './line-grid';
import { XAxis } from './x-axis';
import { pick } from 'lodash';
var cls = classNames('chart-grid');
export var ChartGridDefaultProps = __assign({
  direction: 'vertical',
  lineColor: 'light',
  xAxisLocation: 'bottom',
  showAxis: true,
  showMarks: true,
  showTicks: true,
  maxValue: 1000,
  gridHeight: "400px",
  axisHeight: "30px",
  backgroundColor: 'app-chrome'
}, pick(LineGridDefaultProps, ['majorDivisions', 'minorDivisions', 'majorOpacity', 'minorOpacity', 'middleMinorOpactity', 'majorWidth', 'minorWidth'])); // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    \n    ", "\n  "], ["\n    position: relative;\n    \n    ", "\n  "])), function (_a) {
    var _bg = _a._bg,
        _height = _a._height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: calc(", ");\n      background-color: ", ";\n    "], ["\n      height: calc(", ");\n      background-color: ", ";\n    "])), _height, theme.COLOR(_bg));
  })
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var XAxisStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 30px;\n  "], ["\n    height: 30px;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  XAxis: styled(XAxis)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), XAxisStyles),
  Grid: styled(LineGrid)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
export var ChartGrid = function ChartGrid(props) {
  var className = props.className,
      backgroundColor = props.backgroundColor,
      middleMinorOpacity = props.middleMinorOpacity,
      direction = props.direction,
      lineColor = props.lineColor,
      xAxisLocation = props.xAxisLocation,
      formatTickValue = props.formatTickValue,
      children = props.children,
      majorDivisions = props.majorDivisions,
      xAxisDivisions = props.xAxisDivisions,
      majorOpacity = props.majorOpacity,
      majorWidth = props.majorWidth,
      minorDivisions = props.minorDivisions,
      minorOpacity = props.minorOpacity,
      minorWidth = props.minorWidth,
      showMarks = props.showMarks,
      maxValue = props.maxValue,
      lineWidth = props.lineWidth,
      gridHeight = props.gridHeight,
      axisHeight = props.axisHeight,
      showTicks = props.showTicks,
      showAxis = props.showAxis,
      showAxisLine = props.showAxisLine;
  var gridProps = {
    middleMinorOpacity: middleMinorOpacity,
    direction: direction,
    lineColor: lineColor,
    children: children,
    majorDivisions: majorDivisions,
    majorOpacity: majorOpacity,
    majorWidth: majorWidth,
    minorDivisions: minorDivisions,
    minorOpacity: minorOpacity,
    minorWidth: minorWidth,
    showMarks: showMarks,
    backgroundColor: backgroundColor,
    showAxis: showAxis
  };
  var xAxisProps = {
    maxValue: maxValue,
    divisions: majorDivisions,
    lineColor: lineColor,
    showMarks: showMarks,
    formatTickValue: formatTickValue,
    showLine: showAxisLine,
    showTicks: showTicks,
    markWidth: majorWidth,
    lineWidth: lineWidth || majorWidth
  };
  return React.createElement(My.Container, {
    _height: (showAxis ? axisHeight : 0) + " + " + gridHeight,
    _bg: backgroundColor,
    className: cls.name(className)
  }, showAxis && xAxisLocation === 'top' && React.createElement(My.XAxis, __assign({}, xAxisProps)), React.createElement(My.Grid, __assign({
    height: gridHeight
  }, gridProps)), showAxis && xAxisLocation === 'bottom' && React.createElement(My.XAxis, __assign({}, xAxisProps)));
};
ChartGrid.defaultProps = ChartGridDefaultProps;
ChartGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;